/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Label_GeneratingInputs */

const en_shipping_label_generating = /** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating PDF Shipping Label...`)
};

const es_shipping_label_generating = /** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando Etiqueta de Envío PDF...`)
};

const fr_shipping_label_generating = /** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération de l'étiquette d'expédition PDF...`)
};

const de_shipping_label_generating = /** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Versandetikett wird generiert...`)
};

const id_shipping_label_generating = /** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat Label Pengiriman PDF...`)
};

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const ja_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const zh_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const ar_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const it_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const ru_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const pt_shipping_label_generating = en_shipping_label_generating;

/** @type {(inputs: Shipping_Label_GeneratingInputs) => LocalizedString} */
const ko_shipping_label_generating = en_shipping_label_generating;

/**
* | output |
* | --- |
* | "Generating PDF Shipping Label..." |
*
* @param {Shipping_Label_GeneratingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_label_generating = /** @type {((inputs?: Shipping_Label_GeneratingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Label_GeneratingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_label_generating(inputs)
	if (locale === "es") return es_shipping_label_generating(inputs)
	if (locale === "fr") return fr_shipping_label_generating(inputs)
	if (locale === "de") return de_shipping_label_generating(inputs)
	if (locale === "ja") return ja_shipping_label_generating(inputs)
	if (locale === "zh") return zh_shipping_label_generating(inputs)
	if (locale === "ar") return ar_shipping_label_generating(inputs)
	if (locale === "id") return id_shipping_label_generating(inputs)
	if (locale === "it") return it_shipping_label_generating(inputs)
	if (locale === "ru") return ru_shipping_label_generating(inputs)
	if (locale === "pt") return pt_shipping_label_generating(inputs)
	return ko_shipping_label_generating(inputs)
});